import useEventDispatcher from "../../../../../use/useEventDispatcher";
import isNull from "../../../../../mixin/isNull";

export default function () {
    const eventDispatcher = useEventDispatcher();

    return {
        flash: (element, number = 3, time = 1000) => {
            if (typeof element === "string") {
                element = document.querySelector(element);
            }

            let flashNumber = 0;

            if (element instanceof Element) {
                const bgcolor = window.getComputedStyle(element, null).getPropertyValue("background-color");

                const interval = setInterval(() => {
                    flashNumber++;

                    element.style.background = "#ffeb3b";

                    setTimeout(() => {
                        element.style.background = bgcolor;
                    }, time / 2)

                    if (flashNumber >= number) clearInterval(interval);
                }, time);
            }
        },
        sleep: (milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds)),
        lockInteract: () => {
            eventDispatcher.launcher("lock-interact");
        },
        unlockInteract: () => {
            eventDispatcher.launcher("unlock-interact");
        },
        click: (selector) => {
            const element = document.querySelector(selector);

            if (element instanceof Element) {
                const bgcolor = window.getComputedStyle(element, null).getPropertyValue("background-color");

                element.style.background = "#ffeb3b";

                setTimeout(() => {
                    element.style.background = bgcolor;
                    element.click();
                }, 400);
            }
        },
        type: async (element, content, max = 200, min = 100) => {
            if (typeof element === "string") {
                element = document.querySelector(element);
            }

            if (isNull(element)) return;

            element.style.background = "#ffeb3b";
            element.focus();
            element.click();

            for (let i = 0; i < content.length; i++) {
                await new Promise(resolve => setTimeout(() => {
                    element.value += content[i];

                    resolve();
                }, Math.random() * (max - min) + min));
            }

            element.style.background = "inherit";
        }
    }
}